<app-citizen-header></app-citizen-header>

<div class="w-full bg-service pb-4">
  <div class="p-2">
    <app-portal-title-bar [title]="'Taarifa za Huduma Iliyoombwa'"></app-portal-title-bar>
  </div>

  <div class="mx-8 mt-4 grid gap-6 md:grid-cols-2 lg:grid-cols-[minmax(0,1fr)_420px]">

    <div class="space-y-6" *ngIf="formResponse$ | async as formResponse">

      <section class="bg-white rounded-xl shadow p-6">
        <h3 class="font-bold text-primary-500 mb-4">{{ 'Requested Service' | concat | translate }}</h3>

        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-12 md:col-span-6">
            <span class="text-sm text-gray-500">
              {{ 'Requested Service Name' | concat | translate }}
            </span>
            <p class="font-semibold">{{ formResponse.form?.service?.serviceName }}</p>
          </div>

          <div class="col-span-12 md:col-span-6">
            <span class="text-sm text-gray-500">
              {{ 'Service Category' | concat | translate }}
            </span>
            <p class="font-semibold">
              {{ formResponse.form?.service?.serviceCategory?.categoryName }}
            </p>
          </div>

          <div class="col-span-12">
            <span class="text-sm text-gray-500">
              {{ 'Service Description' | concat | translate }}
            </span>
            <p class="font-medium">
              {{ formResponse.form?.service?.serviceDescription }}
            </p>
          </div>
        </div>
      </section>

      <section class="bg-white rounded-xl shadow p-6">
        <h3 class="font-bold text-primary-500 mb-4">
          {{ 'Submitted Form Details' | concat | translate }}
        </h3>

        <div class="grid grid-cols-12 gap-4">
          @for (resp of submittedFormData; track resp) {
            <div class="col-span-12 md:col-span-6">
              <span class="text-sm text-gray-500">{{ resp.label }}</span>
              @if (!isAttachment(resp.value)) {
                <p class="font-medium">{{ resp.value }}</p>
              } @else {
                <div class="flex">
                  <div (click)="openAttachment(resp.value.replaceAll('data:application/pdf;base64,',''))" class="bg-gray-100 cursor-pointer hover:bg-gray-200 p-2 rounded-full flex gap-2 border">
                    <app-font-awesome-icon iconName="pdf"></app-font-awesome-icon>
                    Attachment
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </section>

      @if (formResponse.latestProcessingStatus) {
        <section class="bg-white rounded-xl shadow p-6">

          <nav class="flex gap-3 mb-4">
            @for (tab of responseTabs; track tab) {
              <button
                type="button"
                class="px-3 py-1 text-sm font-medium rounded-full transition"
                [class.bg-primary-600]="tab.slug === activeSlug"
                [class.text-white]="tab.slug === activeSlug"
                [class.bg-primary-50]="tab.slug !== activeSlug"
                (click)="activeSlug = tab.slug"
              >
                {{ tab.name | concat | translate }}
              </button>
            }
          </nav>

          <ng-container *ngIf="activeSlug === 'current'; else trackingTab">
            <div class="space-y-4">

              <div>
                <span class="text-sm text-gray-500">{{ 'status' | concat | translate }}</span>
                <span
                  class="ml-2 px-2 py-1 rounded-full text-xs font-semibold"
                  [ngClass]="{
                    'bg-success text-white': formResponse.latestProcessingStatus.status === 'COMPLETE',
                    'bg-amber-500 text-white': formResponse.latestProcessingStatus.status === 'PENDING',
                    'bg-gray-200 text-gray-800': !['COMPLETE','PENDING'].includes(formResponse.latestProcessingStatus.status)
                  }"
                >
                  {{ formResponse.latestProcessingStatus.status }}
                </span>
              </div>

              <div class="grid grid-cols-12 gap-4">
                @for (f of formResponse.latestProcessingStatus.modOtherFields; track f) {
                  <div class="col-span-12 md:col-span-6">
                    <span class="text-sm text-gray-500">{{ f.label }}</span>
                    <p class="font-medium">{{ f.value || '-' }}</p>
                  </div>
                }
              </div>

              @if (formResponse.latestProcessingStatus.files?.length) {
                <div>
                  <span class="text-sm text-gray-500">
                    {{ 'attachments' | concat | translate }}
                  </span>
                  <div class="flex gap-2 flex-wrap mt-1">
                    @for (a of formResponse.latestProcessingStatus.files; track a) {
                      <div
                        class="p-2.5 bg-white rounded-xl shadow cursor-pointer hover:bg-primary-100 flex items-center gap-1"
                        (click)="openAttachment(a)"
                      >
                        <mat-icon class="scale-125" svgIcon="pdf"></mat-icon>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </ng-container>

          <ng-template #trackingTab>
            <div class="space-y-4">

              @for (s of formResponse.processingHistory; track s) {
                <div class="p-4 bg-primary-50/30 rounded-xl">
                  <div class="mb-2 flex items-center gap-2">
                    <span class="font-bold text-primary-500">{{ 'status' | concat | translate }}</span>
                    <span
                      class="ml-2 px-2 py-1 rounded-full text-xs font-semibold"
                      [ngClass]="{
                        'bg-success text-white': s.status === 'COMPLETE',
                        'bg-amber-500 text-white': s.status === 'PENDING',
                        'bg-gray-200 text-gray-800': !['COMPLETE','PENDING'].includes(s.status)
                      }"
                    >
                      {{ s.status }}
                    </span>
                  </div>

                  <div class="grid grid-cols-12 gap-4">
                    @for (f of s.modOtherFields; track f) {
                      <div class="col-span-12 md:col-span-6">
                        <span class="text-sm text-gray-500">{{ f.label }}</span>
                        <p class="font-medium">{{ f.value || '-' }}</p>
                      </div>
                    }
                  </div>

                  @if (s.files?.length) {
                    <div class="mt-2">
                      <span class="text-sm text-gray-500">
                        {{ 'attachments' | concat | translate }}
                      </span>
                      <div class="flex gap-2 flex-wrap mt-1">
                        @for (a of s.files; track a) {
                          <div
                            class="p-2.5 bg-white rounded-xl shadow cursor-pointer hover:bg-primary-100 flex items-center gap-1"
                            (click)="openAttachment(a)"
                          >
                            <mat-icon class="scale-125" svgIcon="pdf"></mat-icon>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }

              @if (!formResponse.processingHistory?.length) {
                <div class="p-10 text-center bg-white/60 rounded-xl">Hakuna Majibu</div>
              }
            </div>
          </ng-template>
        </section>
      } @else {
        <section class="p-10 text-center bg-white/60 rounded-xl">
          Hakuna Majibu kwa Sasa
        </section>
      }
      <section class="p-10 bg-white/60 rounded-xl">
        <h3 class="font-bold text-primary-500 mb-4">{{ 'Tuma Mrejesho' | concat | translate }}</h3>

      <app-feedback-window
        [serviceUniqueId]="formResponse?.form?.service?.serviceUniqueId"
      ></app-feedback-window>
      </section>


    </div>

    <aside>
      <section class="space-y-6">
      <section class="bg-white rounded-xl shadow p-6">
        <h3 class="font-bold mb-3">Mchakato wa huduma</h3>

        <div class="flex flex-col gap-2" *ngIf="serviceSteps$ | async as steps">
          @for (s of steps; track s) {
            <div class="flex gap-2">
              <span class="font-bold">{{ $index + 1 }}.</span>

              <div class="grow border-2 border-primary-50/80 p-0.5 rounded-2xl">
                <div class="p-2 bg-primary-50/80 rounded-xl">
                  <span class="font-semibold">{{ s.stepName }}</span>
                  <div class="text-sm">
                    <ng-container *ngIf="s.stepTimeInYear"> {{ s.stepTimeInYear }} Miaka </ng-container>
                    <ng-container *ngIf="s.stepTimeInMonths"> {{ s.stepTimeInMonths }} Miezi </ng-container>
                    <ng-container *ngIf="s.stepTimeInWeeks"> {{ s.stepTimeInWeeks }} Wiki </ng-container>
                    <ng-container *ngIf="s.stepTimeInDays"> {{ s.stepTimeInDays }} Siku </ng-container>
                    <ng-container *ngIf="s.stepTimeInMinutes"> {{ s.stepTimeInMinutes }} Dakika </ng-container>
                    <ng-container *ngIf="s.stepTimeInSec"> {{ s.stepTimeInSec }} Sekunde </ng-container>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </section>
      <section class="bg-white rounded-xl shadow p-6 flex flex-col h-full">
          <h3 class="font-bold text-primary-500 mb-4">Comments</h3>

          <div class="flex-1 space-y-3 overflow-y-auto pr-1" *ngIf="comments$ | async as comments">
            @for (c of comments; track c.uniqueId) {
              <div
                class="flex w-full"
                [ngClass]="{
                'justify-end': c.commentBy?.profileUniqueId === currentProfileUniqueId,
                'justify-start': c.commentBy?.profileUniqueId !== currentProfileUniqueId
              }"
              >
                <div
                  class="max-w-[75%] flex gap-2 items-start"
                  [ngClass]="{ 'flex-row-reverse': c.commentBy?.profileUniqueId === currentProfileUniqueId }"
                >
                  <mat-icon
                    fontIcon="chat"
                    class="shrink-0 mt-1"
                    [ngClass]="{
                    'text-primary-600': c.commentBy?.profileUniqueId === currentProfileUniqueId,
                    'text-gray-400': c.commentBy?.profileUniqueId !== currentProfileUniqueId
                  }"
                  ></mat-icon>

                  <div
                    class="rounded-xl px-3 py-2 break-words"
                    [ngClass]="{
                    'bg-primary-600 text-white': c.commentBy?.profileUniqueId === currentProfileUniqueId,
                    'bg-gray-100  text-gray-800': c.commentBy?.profileUniqueId !== currentProfileUniqueId
                  }"
                  >
                    <p class="text-sm leading-snug">{{ c.comment }}</p>
                    <span class="text-[10px] opacity-75">{{ c.createdAt | date:'medium' }}</span>
                  </div>
                </div>
              </div>
            }
            @if (comments.length === 0) {
              <p class="text-muted italic">No comments yet.</p>
            }
          </div>

          <form [formGroup]="commentForm" (ngSubmit)="sendComment()" class="mt-4 flex gap-2">
          <textarea
            matInput
            formControlName="comment"
            placeholder="Write a comment..."
            class="flex-1 border rounded-md p-2 resize-y min-h-[48px]"
          ></textarea>
            <button
              mat-flat-button
              color="primary"
              class="h-[48px] px-6"
              [disabled]="commentForm.invalid"
            >
              Send
            </button>
          </form>
        </section>
      </section>
    </aside>
  </div>

</div>
<app-portal-footer></app-portal-footer>
